define([
	"dojo/_base/declare",
	"csi/access/crews",
	"csi/action/NewFrom",
	"csi/def",
	"Apparel/ProductType"
], function(declare,crews,NewFrom,def,ProductType) {

	return declare(NewFrom, {
		validate: function(/*Context*/ctx) {
			// summary: don't show action is user does not have proper access
			var	material = ctx.getNode();
			return material &&
				material.UsableForStyleBOM &&
				def.canNavigateToType("Theme") &&
				crews.isInGlobalRoles(["Theme Administrator","Theme Editor"]) &&
				ProductType.hasColor(material) &&
				this.inherited(arguments);
		}
	});
});